var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "modal-dialog modal-lg", attrs: { role: "document" } },
    [
      _c("div", { staticClass: "modal-content" }, [
        _c("div", { staticClass: "modal-header" }, [
          _c(
            "h5",
            { staticClass: "modal-title", attrs: { id: "exampleModalLabel" } },
            [_vm._t("default")],
            2
          ),
          _c("button", {
            staticClass: "btn-close",
            attrs: {
              type: "button",
              "data-bs-dismiss": "modal",
              "aria-label": "Close",
            },
            on: { click: _vm.clear },
          }),
        ]),
        _c("div", { staticClass: "modal-body" }, [
          _c("div", { staticClass: "mt-3" }, [
            _c(
              "label",
              {
                staticClass: "form-label",
                attrs: { for: "exampleInputEmail1" },
              },
              [_vm._v("Item Name*")]
            ),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.itemName,
                  expression: "itemName",
                },
              ],
              staticClass: "form-control",
              attrs: { type: "text" },
              domProps: { value: _vm.itemName },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.itemName = $event.target.value
                },
              },
            }),
          ]),
          _c("div", { staticClass: "mt-3" }, [
            _c(
              "label",
              {
                staticClass: "form-label",
                attrs: { for: "exampleInputEmail1" },
              },
              [_vm._v("Item Description")]
            ),
            _c("textarea", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.itemDescription,
                  expression: "itemDescription",
                },
              ],
              staticClass: "form-control pl-3",
              attrs: {
                placeholder: "Details of the item",
                id: "floatingTextarea",
              },
              domProps: { value: _vm.itemDescription },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.itemDescription = $event.target.value
                },
              },
            }),
          ]),
          _c("div", { staticClass: "form-check mt-3" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.enable_special_instructions,
                  expression: "enable_special_instructions",
                },
              ],
              staticClass: "form-check-input",
              attrs: { type: "checkbox", id: "enable_special_instructions" },
              domProps: {
                checked: Array.isArray(_vm.enable_special_instructions)
                  ? _vm._i(_vm.enable_special_instructions, null) > -1
                  : _vm.enable_special_instructions,
              },
              on: {
                change: function ($event) {
                  var $$a = _vm.enable_special_instructions,
                    $$el = $event.target,
                    $$c = $$el.checked ? true : false
                  if (Array.isArray($$a)) {
                    var $$v = null,
                      $$i = _vm._i($$a, $$v)
                    if ($$el.checked) {
                      $$i < 0 &&
                        (_vm.enable_special_instructions = $$a.concat([$$v]))
                    } else {
                      $$i > -1 &&
                        (_vm.enable_special_instructions = $$a
                          .slice(0, $$i)
                          .concat($$a.slice($$i + 1)))
                    }
                  } else {
                    _vm.enable_special_instructions = $$c
                  }
                },
              },
            }),
            _c(
              "label",
              {
                staticClass: "form-check-label",
                attrs: { for: "addsToPrice" },
              },
              [_vm._v("Enable Special Instructions")]
            ),
          ]),
          _c("div", { staticClass: "form-check mt-3" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.isVIP,
                  expression: "isVIP",
                },
              ],
              staticClass: "form-check-input",
              attrs: { type: "checkbox", id: "enable_special_instructions" },
              domProps: {
                checked: Array.isArray(_vm.isVIP)
                  ? _vm._i(_vm.isVIP, null) > -1
                  : _vm.isVIP,
              },
              on: {
                change: function ($event) {
                  var $$a = _vm.isVIP,
                    $$el = $event.target,
                    $$c = $$el.checked ? true : false
                  if (Array.isArray($$a)) {
                    var $$v = null,
                      $$i = _vm._i($$a, $$v)
                    if ($$el.checked) {
                      $$i < 0 && (_vm.isVIP = $$a.concat([$$v]))
                    } else {
                      $$i > -1 &&
                        (_vm.isVIP = $$a
                          .slice(0, $$i)
                          .concat($$a.slice($$i + 1)))
                    }
                  } else {
                    _vm.isVIP = $$c
                  }
                },
              },
            }),
            _c(
              "label",
              {
                staticClass: "form-check-label",
                attrs: { for: "addsToPrice" },
              },
              [_vm._v("VIP item")]
            ),
          ]),
          _c("div", { staticClass: "mt-3" }, [
            _c(
              "label",
              { staticClass: "form-label", attrs: { for: "exampleInputCost" } },
              [_vm._v("Cost")]
            ),
            _c("div", { staticClass: "input-group mb-3" }, [
              _vm._m(0),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.cost,
                    expression: "cost",
                  },
                ],
                staticClass: "form-control",
                attrs: {
                  type: "number",
                  step: "0.01",
                  id: "exampleInputCost",
                  "aria-label": "Amount (to the nearest dollar)",
                },
                domProps: { value: _vm.cost },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.cost = $event.target.value
                  },
                },
              }),
              _c("div", { staticClass: "input-group-append" }, [
                _c("span", { staticClass: "input-group-text" }, [
                  _vm._v(
                    _vm._s(_vm.formattedCost == "NaN" ? 0.0 : _vm.formattedCost)
                  ),
                ]),
              ]),
            ]),
          ]),
          _c("div", { staticClass: "mt-3" }, [
            _vm.previewImage
              ? _c("img", {
                  staticClass: "uploading-image card-picture-size",
                  attrs: { src: _vm.previewImage },
                })
              : _vm._e(),
            _c("input", {
              attrs: {
                type: "file",
                accept: "image/jpeg",
                "v-model": _vm.picture,
              },
              on: { change: _vm.uploadImage },
            }),
          ]),
          _c(
            "div",
            { staticClass: "btn-group float-right", attrs: { role: "group" } },
            [
              _c(
                "button",
                {
                  staticClass: "btn btn-sucess",
                  attrs: { type: "button", "data-bs-dismiss": "modal" },
                  on: {
                    click: function ($event) {
                      return _vm.save()
                    },
                  },
                },
                [_vm._v("Save")]
              ),
              _c(
                "button",
                {
                  staticClass: "btn btn-secondary mx-3",
                  attrs: { type: "button", "data-bs-dismiss": "modal" },
                  on: { click: _vm.clear },
                },
                [_vm._v("Cancel")]
              ),
            ]
          ),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "input-group-prepend" }, [
      _c("span", { staticClass: "input-group-text" }, [_vm._v("$")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }